import React from 'react'
import { useState } from 'react'

// All svg files
import logo from "../assets/logo.svg"
import Home from "../assets/home-solid.svg"
import Team from "../assets/social.svg"
import Calender from "../assets/sceduled.svg"
import Projects from "../assets/starred.svg"
import Documents from "../assets/draft.svg"
import PowerOff from "../assets/power-off-solid.svg"
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'


const Container = styled.div`
position: fixed;

.active{
    border-right: 4px solid var(--white);

    img{
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(241deg) brightness(103%) contrast(103%);
}

`

const Button = styled.button`
background-color: var(--black);
border: none;
width: 2.5rem;
height: 2.5rem;
border-radius: 50%;
margin: 0.5rem 0 0 0.5rem;
cursor: pointer;

display: flex;
justify-content: center;
align-items: center;

position: relative;

&::before,
&::after{
    content:"";
    background-color: var(--white);
    height: 2px;
    width: 1rem;
    position: absolute;
    transtion: all 0.3s ease;
}

&::before{
    top: ${(props) => (props.clicked ? "1.5" : "1rem")};
    transform: ${(props => props.clicked ? "rotate(135deg)" : "rotate(0)")}
}
&::after{
    top:${(props) => (props.clicked ? "1.2" : "1.5rem")};;
    transform: ${(props => props.clicked ? "rotate(-135deg)" : "rotate(0)")}
}
`;

const SidebarContainer = styled.div`
background-color: var(--black);
width: 3.5rem;
height: 80vh;
margin-top: 1rem;
border-radius: 0 30px 30px 0;
padding: 1rem 0;


display: flex;
flex-direction: column;
align-items: center;
justify-content: space-between;

position: relative;

`;
const Logo = styled.div`
width: 2.5rem;

img{
    width: 100%;
    height: auto;
}
`;
const SlickBar = styled.ul`
color: var(--white);
list-style: none;
display: flex;
flex-direction: column;
align-items: center;
background-color: var(--black);

padding: 2rem 0;

position: absolute;
top: 6rem;
left: 0;

width: ${props => props.clicked ? "12rem" : "3.5rem"};
transition: all 0.5s ease;
border-radius: 0 30px 30px 0;

`;
const Item = styled(NavLink)`
text-decoration: none;
color: var(--white);

width: 100%;
padding: 1rem 0;cursor: pointer;

display: flex;

padding-left: 1rem;
&:hover{
    border-right: 4px solid var(--white);

    img{
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(241deg) brightness(103%) contrast(103%);
    }
}

img{
    width: 1.2rem;
    height: auto;
    filter: invert(99%) sepia(36%) saturate(1756%) hue-rotate(173deg) brightness(80%) contrast(79%);
}



`;
const Text = styled.span`
width: ${(props) => (props.clicked ? "100%" : "0")};
overflow: hidden;
margin-left: ${(props) => (props.clicked ? "1.5rem" : "0")};
transition: all 0.3s ease;


`;
const Profile = styled.div`
width: ${props => props.clicked ? "14rem" : "3rem"};
height: 3rem;

padding: 0.5rem 1rem;
border-radius: 20px;

display: flex;
align-items: center;
justify-content: center;
margin-left: ${(props) => (props.clicked ? "9rem" : "0")};

background-color: var(--black);
color: var(--white);

transition: all 0.3s ease;


img{
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    cursor: pointer;

    &:hover{
        border: 2px solid var(--grey);
        padding: 2px;
    }
   }
`;
const Details = styled.div`
display: ${(props) => (props.clicked ? "flex" : "none")};
justify-content: space-between;
align-items: center;
`;

const Name = styled.div`
padding: 0 1.5rem;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

h4{
    display: inline-block;
}

a{
    font-size: 0.7rem;
    text-decoration: none;
    color: var(--grey);

    &:hover{
        text-decoration: underline;
    }
}

`
const Logout = styled.button`
border: none;
width: 2rem;
height: 2rem;
background-color: transparent;

img{
    width: 100%;
    height: auto;
    filter: invert(14%) sepia(90%) saturate(6863%) hue-rotate(359deg) brightness(105%) contrast(109%);
    transition: all 0.3s ease;

    &:hover{
        padding: 0;
        border: none;
        opacity: 0.5;
    }
}

`

const Sidebar = () => {

    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const [profileClick, setprofileClick] = useState(false);
    const handleProfileClick = () => setprofileClick(!profileClick);

    return (
        <Container>
            <Button clicked={click} onClick={() => handleClick()}>
                Click
            </Button>
            <SidebarContainer>
                <Logo>
                    <img src={logo} alt="logo" />
                </Logo>
                <SlickBar clicked={click}>
                    <Item onClick={() => setClick(false)} exact activeClassName="active" to="/" >
                        <img src={Home} alt="Home" />
                        <Text clicked={click}>Home</Text>
                    </Item>
                    <Item onClick={() => setClick(false)} exact activeClassName="active" to="/team">
                        <img src={Team} alt="Team" />
                        <Text clicked={click}>Team</Text>
                    </Item>
                    <Item onClick={() => setClick(false)} exact activeClassName="active" to="/calender">
                        <img src={Calender} alt="Calender" />
                        <Text clicked={click}>Calender</Text>
                    </Item>
                    <Item onClick={() => setClick(false)} exact activeClassName="active" to="/documents">
                        <img src={Documents} alt="Documents" />
                        <Text clicked={click}>Documents</Text>
                    </Item>
                    <Item onClick={() => setClick(false)} exact activeClassName="active" to="/projects">
                        <img src={Projects} alt="Products" />
                        <Text clicked={click}>Products</Text>
                    </Item>
                </SlickBar>

                <Profile clicked={profileClick}>
                    <img
                        onClick={() => handleProfileClick()}
                        src="https://picsum.photos/200"
                        alt="Profile"
                    />
                    <Details clicked={profileClick}>
                        <Name>
                            <h4>Faheem</h4>
                            <a href="#">View Profile</a>
                        </Name>

                        <Logout>
                            <img src={PowerOff} alt="logout" />
                        </Logout>
                    </Details>
                </Profile>
            </SidebarContainer>
        </Container>
    )
}

export default Sidebar;